"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CARD_SCALE = 0.83;
var _default = exports.default = {
  name: "ElCarouselItem",
  data: function data() {
    return {
      isShow: false,
      hover: false,
      translate: 0,
      scale: 1,
      active: false,
      inStage: false,
      animating: false
    };
  },
  props: {
    name: String,
    label: {
      type: [String, Number],
      default: ""
    }
  },
  methods: {
    processIndex: function processIndex(index, activeIndex, length) {
      if (activeIndex === 0 && index === length - 1) {
        return -1;
      } else if (activeIndex === length - 1 && index === 0) {
        return length;
      } else if (index < activeIndex - 1 && activeIndex - index >= length / 2) {
        return length + 1;
      } else if (index > activeIndex + 1 && index - activeIndex >= length / 2) {
        return -2;
      }
      return index;
    },
    calcCardTranslate: function calcCardTranslate(index, activeIndex) {
      var parentEl = this.$parent && this.$parent.$el;
      var parentWidth = parentEl ? parentEl.offsetWidth : 0;
      if (!parentWidth) return 0;
      if (index === activeIndex) {
        return parentWidth * ((2 - CARD_SCALE) * (index - activeIndex) + 1) / 8;
      } else if (index < activeIndex) {
        return -((1 - CARD_SCALE) * parentWidth * 3) / 8;
      } else {
        return (4 - 3 * CARD_SCALE - 3 * (1 - CARD_SCALE) / 2) * parentWidth / 4;
      }
    },
    calcTranslate: function calcTranslate(index, activeIndex) {
      var parentEl = this.$parent && this.$parent.$el;
      var distance = parentEl ? parentEl.offsetWidth : 0;
      return distance * (index - activeIndex);
    },
    translateItem: function translateItem(index, activeIndex, oldIndex) {
      var length = this.$parent.items.length;
      if (index !== activeIndex && length > 2 && this.$parent.loop) {
        index = this.processIndex(index, activeIndex, length);
      }
      // this.active = index === activeIndex;
      // this.translate = this.calcTranslate(index, activeIndex);

      this.inStage = Math.round(Math.abs(index - activeIndex)) <= 1;
      this.active = index === activeIndex;
      this.translate = this.calcCardTranslate(index, activeIndex);
      // this.translate = this.calcTranslate(index, activeIndex);
      this.scale = this.active ? 1 : CARD_SCALE;
      this.isShow = true;
    }
  },
  computed: {
    itemStyle: function itemStyle() {
      var value = "translateX(".concat(this.translate, "px) scale(").concat(this.scale, ")");
      var style = {
        transform: value,
        WebkitTransform: value
      };
      return style;
    }
  },
  mounted: function mounted() {
    this.$parent && this.$parent.updateItems();
  },
  destroyed: function destroyed() {
    this.$parent && this.$parent.updateItems();
  }
};